import { render, staticRenderFns } from "./ReturnHome.vue?vue&type=template&id=1c199048&scoped=true"
import script from "./ReturnHome.vue?vue&type=script&lang=js"
export * from "./ReturnHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c199048",
  null
  
)

export default component.exports